<template>
  <div class="register absolute">
    <div class="shading">
      <div class="pictrue acea-row row-center-wrapper">
  
        <img src="@assets/images/logo2.png" >
      </div>
    </div>
    <div class="whiteBg" v-if="formItem === 1">
      <div class="title acea-row row-center-wrapper">
        <div class="item on" >
        系统登录
        </div>
      </div>
      <div class="list"  >
        <form @submit.prevent="submit">
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-phone_"></use>
              </svg>
              <input
                type="text"
                placeholder="输入账号"
                v-model="username"
                required
              />
            </div>
          </div>
          <div class="item">
            <div class="acea-row row-between-wrapper">
              <svg class="icon" aria-hidden="true">
                <use xlink:href="#icon-code_"></use>
              </svg>
              <input
                type="password"
                placeholder="填写登录密码"
                v-model="password"
                required
              />
            </div>
          </div>
        </form>
        
      </div>
    
     
      <div class="logon" @click="submit"  >登录</div>
      <div class="tip">
      
      </div>
    </div>
     
    
  </div>
</template>
<script>
 
import {
  login
} from "@api/user";
import attrs, { required, alpha_num, chs_phone } from "@utils/validate";
import { validatorDefaultCatch } from "@utils/dialog";
 
import cookie from "@utils/store/cookie";
import { VUE_APP_API_URL } from "@utils";

const BACK_URL = "login_back_url";

export default {
  name: "Login",

  data: function() {
    return {
      navList: ["系统登录"],
      current: 0,
      username: "",
      password: "",
      captcha: "",
      formItem: 1,
      type: "login",
      logoUrl: "",
      keyCode: "",
      codeUrl: "",
      codeVal: "",
      isShowCode: false
    };
  },
  mounted: function() {
     
 
  },
  methods: {
    
   
 
 
    navTap: function(index) {
      this.current = index;
    },
    async submit() {
	var that = this;
      const { username, password } = this;
      try {
        await this.$validator({
          username: [
            required(required.message("账号"))
          ],
          password: [
            required(required.message("密码"))
          ]
        }).validate({ username, password });
      } catch (e) {
        return validatorDefaultCatch(e);
      }

      login({ username, password })
	 
	  
	  
	.then(res => {
		     console.log(res);
 if(res.code==0){
   this.$dialog.error(res.msg);
 }else{
          const datas = {
            uid: res.data.id,
            username: res.data.username,
			ygname: res.data.ygname,
            dm_id: res.data.dm_id,
            dm_name: res.data.dm_name,
            qx: res.data.qx,
			goodslist: res.data.goodslist 
          };
		 
	 
          this.$store.commit("LOGIN", datas);
		   const backUrl =  "/";
		 if(res.data.qx==4 || res.data.qx==2){
		 
		  
          const backUrl =  "/";
		  }
		   if(res.data.qx==15){
		 
		  
          const backUrl =  "/huizong";
		  }
		     if(res.data.qx==3){
		 
		  
          const backUrl =  "/caigou";
		  }
		  console.log(backUrl);
         cookie.remove(BACK_URL);
          this.$router.replace({ path: backUrl });
		  }
        })
        .catch(e => {
          this.$dialog.error(e.msg);
        });

      
    }
  }
};
</script>
<style scoped>
 
</style>
